import React from 'react';

import { SSection, SSectionContent } from './styles';

const Section = ({
    children,
    background,
    forwardedRef,
    id,
}) => (
    <SSection
        background={ background }
        ref={ forwardedRef }
        id={ id }
    >
        <SSectionContent>
            { children }
        </SSectionContent>
    </SSection>
);

export default Section;
